const INITIAL_STATE = {
    quote_listing: [],
    listingMeta: null,
    listing_tbl_page: 1,

    quoteSearchForm: null,
    submittedPOFilterForm: null,

    formSearchedElems: [],

    searchedItem: [],
    searchedCustomer: [],
    searchedDeals: [],
    searchedCustomerProject: [],
    searchedAssets: [],
    searchedWorkstation: [],
    searchedEmployees: [],
    searchedSubassembly: [],

    listingCustomers: [],
    listingStatuses: [],
    listingWarehouses: [],

    totalListingCount: 0,
    hasLoaded: false,
};

export default function salesOrderListReducer(state = INITIAL_STATE, action) {

    switch (action.type) {

        case 'SET_SALES_ORDER_LIST_STATE':
            return {
                ...state,
                ...action.payload
            };

        case 'CLEAR_SALES_ORDER_LIST_STATE':
            return INITIAL_STATE;

        default:
            return state;
    }
}
